import './AccordionGroup.scss';
import React from 'react';
import { AccordionGroupData } from '../../../models/app-data-model';
import AccordionComponent from '../../accordion/Accordion';
import { Box } from '@mui/material';

export type AccordionGroupProps = {
  accordionGroup: AccordionGroupData;
};

const AccordionGroup: React.FC<AccordionGroupProps> = ({ accordionGroup }: AccordionGroupProps) => {
  const accordions = accordionGroup.accordions.map((accordion, index) => {
    const accordionContent = accordion.reference[0]?.content || accordion.reference[0]?.answer;
    const accordionTitle = accordion.reference[0]?.title;
    const showExpanded = accordion?.expanded;

    return (
      accordionContent &&
      accordionTitle && (
        <AccordionComponent content={accordionContent} title={accordionTitle} showExpanded={showExpanded} key={index} />
      )
    );
  });

  return <Box className="accordion-group">{accordions}</Box>;
};

export default AccordionGroup;
